import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Camera, latlngConvert } from "@classes/camera/camera";
import { CamerasService } from "@services/cameras/cameras.service";

export interface DialogData {
  camera: Camera;
}

@Component({
  selector: 'app-camera-option',
  templateUrl: './camera-option.component.html',
  styleUrls: ['./camera-option.component.scss']
})
export class CameraOptionComponent implements OnInit {
  title = 'My first AGM project';
  lat = 50.53596263176831;
  lng = 3.557234929548175;
  zoom = 10
  cameras: Camera[];
  constructor(

    private cameraService: CamerasService,
    public dialogRef: MatDialogRef<CameraOptionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,) { }

  ngOnInit(): void {

    this.getCamera()
  }

  private getCamera(): void {

    if (this.data.camera.application.ApplicationName === 'SmartWaste') {
      const latLngSplit = (this.data.camera.location as string)?.split(',');
      this.data.camera.location = new latlngConvert(+latLngSplit[0], +latLngSplit[1])
    }
  }
}
